<span i18n>
  You will be auto-logged out due to inactivity in {{ timeRemaining }} seconds
</span>
